export const WalletIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66699 3C2.66699 2.44772 3.1147 2 3.66699 2H15.667C16.2193 2 16.667 2.44772 16.667 3V4.00005H2.66699V3ZM18.667 3V4.00005H19.667C21.3239 4.00005 22.667 5.34319 22.667 7.00005V17C22.667 18.6569 21.3239 20 19.667 20H3.66703C2.01018 20 0.667032 18.6569 0.667032 17.0001L0.667002 4.99979L0.666992 3.00001C0.666988 1.34315 2.01013 0 3.66699 0H15.667C17.3239 0 18.667 1.34315 18.667 3ZM17.167 10C18.2716 10 19.167 10.8954 19.167 12C19.167 13.1046 18.2716 14 17.167 14C16.0624 14 15.167 13.1046 15.167 12C15.167 10.8954 16.0624 10 17.167 10Z"
      fill="currentColor"
    />
  </svg>
);
